<template>
  <b-navbar toggleable="sm" type="dark" variant="dark">
        <b-navbar-brand to="/">
          <img class="navbar-logo" src="./../assets/logo_amdx_light.png" alt="amdx-ems">
        </b-navbar-brand>
        <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>
        <b-collapse id="nav-text-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/power"><b-icon-power></b-icon-power> Power</b-nav-item>
            <b-nav-item to="/content"><b-icon-images></b-icon-images> Content</b-nav-item>
            <b-nav-item to="/timeline"><b-icon-clock></b-icon-clock> Timeline</b-nav-item>
            <b-nav-item to="/control"><b-icon-Terminal></b-icon-Terminal> DirectControl</b-nav-item>
            <b-nav-item-dropdown>
              <template slot="button-content">
                <b-icon-gear-wide-connected></b-icon-gear-wide-connected> Settings
              </template>
              <b-dropdown-item to="/clients"><b-icon-display></b-icon-display> Clients</b-dropdown-item>
              <b-dropdown-item to="/drivers"><b-icon-box-seam></b-icon-box-seam> Drivers</b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item to="/docs"><b-icon-question-circle></b-icon-question-circle> Docs</b-nav-item>
          </b-navbar-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item-dropdown>
              <template v-slot:button-content v-if="userInfo">
                <b-icon-person-circle></b-icon-person-circle> {{ userInfo.preferred_username }}
              </template>
              <b-dropdown-item to="/profile">Profile</b-dropdown-item>
              <b-dropdown-item @click="logout">Sign Out</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-navbar-nav>
            <span class="version-tag">ems.version: {{ $VUE_APP_VERSION }}</span>
        </b-collapse>
      </b-navbar>
</template>

<script>
  export default {
    name: 'Navbar',
    data () {
      return {
        userInfo: null
      }
    },
    methods: {
      loadUserInfo () {
        if (this.$keycloakmanager.isConfigured) {
          this.$keycloakmanager.loadUserInfo()
            .then(res => {
              this.userInfo = res
            }).catch(err => {
              console.log(err)
            })
        }
      },
      logout () {
        if (this.$keycloakmanager.isConfigured) {
          this.$keycloakmanager.logout()
        }
      }
    },
    mounted () {
      this.loadUserInfo()
    }
  }
</script>

<style lang="scss" scoped>
  .navbar{
    border-bottom: 3px solid #ff5700;

    .version-tag {
      color: #fff;
      font-size: 12px;
    }
  }
  .navbar-logo {
      height: 36px;
  }
  .main-nav{
    .nav-link {
      color: #fff!important;
      .b-icon {
        margin-right: 5px;
      }
    }
    li {
      margin-left: 15px;
    }
    .nav-link.active  {
      color: #ff5700!important;
    }
  }
</style>
